module.exports = __webpack_public_path__ + "static/media/bi_mascot_ddory.c5bb98f2.png";